import axios from "axios";

function requestRegistGrave(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/grave/regist/grave`,
    parameter
  );
}
function requestDeleteGrave(parameter) {
  return axios.post(
    `${
      process.env.VUE_APP_BASEURL
    }/api/app/grave/delete/grave?id=${encodeURIComponent(parameter)}`
  );
}
export { requestRegistGrave, requestDeleteGrave };
